export const environment = {
  production: true,
  applicationUrl: 'https://vfifc.com',
  baseUrl: 'https://api.vfifc.com/vfifc/',
  sumsubAccessTokenUrl: 'https://api.vfifc.com/vfifc/public/sumsub/access-token',
  //Payment
  iveriApplicationId: '60871ec3-78b5-4b6e-860d-d977b8d8e8c0',
  iveriGateway: 'https://portal.host.iveri.com/threedsecure/EnrollmentInitial',
  iveriReturnUrl: 'https://api.vfifc.com/vfifc/public/payment/authenticate',
  zimswitchGateway: 'https://eu-test.oppwa.com/v1/',
  paymentRedirectUrl: 'https://vfifc.com/payment/status/',
};